import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Product } from './product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {




  constructor(private http: HttpClient, private globle: Globle, private localStorage: LocalStorageService) {


  }

  getAll(subCatgId: number, status: number) {
    return this.http.get<Product[]>(this.globle.APIURL + "allproducts/" + subCatgId + "?status=" + status);
  }

  getById(id: number) {
    return this.http.get<Product>(this.globle.APIURL + "productbyid/" + id);
  }

  Create(product: Product) {
    return this.http.post(this.globle.APIURL + "products", product)
  }

  Update(product: Product) {
    return this.http.put(this.globle.APIURL + "products", product)
  }

  Delete(id: number) {
    return this.http.delete(this.globle.APIURL + "products/" + id)
  }

  uploadImage(formdata: any) {
    return this.http.post<any>(this.globle.APIURL + "products/upload", formdata)
  }

  deleteProductCard(id: number) {
    return this.http.delete(this.globle.APIURL + "productcards/" + id)
  }

  getUserCategory() {
    return this.http.get<[]>(this.globle.APIURL + "usercategory");
  }

}
